var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.903)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392,475.653a.492.492,0,0,1-.348-.839l9.182-9.182a.492.492,0,0,1,.7.7l-9.182,9.182A.49.49,0,0,1,392,475.653Z",
    transform: "translate(-391.513 -465.487)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.295 2.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399,482.653a.492.492,0,0,1-.348-.839l9.182-9.182a.492.492,0,0,1,.7.7l-9.182,9.182A.49.49,0,0,1,399,482.653Z",
    transform: "translate(-398.513 -472.487)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.3,468.1a.491.491,0,0,1-.371-.815,1.27,1.27,0,0,0-.09-1.5,1.108,1.108,0,0,0-.781-.3,1.1,1.1,0,0,0-.715.187.492.492,0,0,1-.679-.712,1.992,1.992,0,0,1,1.422-.458,2.061,2.061,0,0,1,1.47.612,2.242,2.242,0,0,1,.113,2.821A.491.491,0,0,1,422.3,468.1Z",
    transform: "translate(-419.513 -464.499)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388,498.078a.492.492,0,0,1-.462-.66l1.312-3.607a.492.492,0,1,1,.924.336l-.951,2.617,2.617-.951a.492.492,0,0,1,.336.924l-3.607,1.312A.491.491,0,0,1,388,498.078Z",
    transform: "translate(-387.512 -493.487)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.4,489.867H370a.492.492,0,0,1-.492-.492v-16.4a.492.492,0,0,1,.492-.492H380.5a.492.492,0,1,1,0,.984h-10v15.412h15.413v-10a.492.492,0,0,1,.984,0v10.489a.492.492,0,0,1-.492.492Z",
    transform: "translate(-369.512 -472.487)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNote);
export default __webpack_public_path__ + "static/media/NewNote.95bf00cf71e6287efb9766b263c903c5.svg";
export { ForwardRef as ReactComponent };